import { render, staticRenderFns } from "./docket.vue?vue&type=template&id=36fb31ca&"
import script from "./docket.vue?vue&type=script&lang=js&"
export * from "./docket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports